import React, { Fragment, useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { SnackbarProvider } from "notistack";

import Signin from "./components/authentication/Signin";
import OperationCenter from "./components/interfaces/OperationCenter";
import Events from "./components/interfaces/Events";
import Communication from "./components/interfaces/Communication";
import Analysis from "./components/interfaces/Analysis";
import Assessment from "./components/interfaces/Assessment";
import MainHeader from "./components/utils/MainHeader";
import CommunityRiskAssessment from "./components/interfaces/CommunityRiskAssessment";
import GroundData from "./components/interfaces/GroundData";
import CapacityAndVulnerability from "./components/interfaces/CapacityAndVulnerability";
import HazardMapping from "./components/interfaces/HazardMapping";
import Rainfall from "./components/interfaces/Rainfall";
import Subsurface from "./components/interfaces/Subsurface";
import Surficial from "./components/interfaces/Surficial";
import Earthquake from "./components/interfaces/Earthquake";
import SurficialMarkers from "./components/interfaces/SurficialMarkers";
import Moms from "./components/interfaces/Moms";
import Feedback from "./components/interfaces/Feedback";
import ChangePassword from "./components/utils/ChangePassword";
import ProfileSettings from "./components/utils/ProfileSettings";
import Bulletin from "./components/utils/Bulletin";
import Resources from "./components/interfaces/Resources";
import "./components/interfaces/css/sandbox.css";
import "./components/interfaces/css/embla.css";

import { CBEWSL_SITE_NAME } from "./host";

const App = (props) => {
  const [nav, setNav] = useState(null);
  const Header = () => {
    let location = window.location.pathname;
    if (location !== "/signin" && location !== "" && location !== "/") {
      if (localStorage.getItem("blc_credentials") !== null) {
        return <MainHeader />;
      }
    } else {
      if (localStorage.getItem("blc_credentials") !== null) {
        window.location = "/opcen";
      }
    }
  };

  return (
    <Fragment>
      <SnackbarProvider>
        <Router homepage="">
          {Header()}
          <Routes>
            <Route exact path={``} element={<Signin />} />
            <Route exact path={`/signin`} element={<Signin />} />
            <Route exact path={`/feedback`} element={<Feedback />} />
          </Routes>

          {localStorage.getItem("blc_credentials") != null && (
            <Routes>
              <Route exact path={`/opcen`} element={<OperationCenter />} />
              <Route exact path={`/bulletin`} element={<Bulletin />} />
              <Route exact path={`/events`} element={<Events />} />
              <Route
                exact
                path={`/communication`}
                element={<Communication />}
              />
              <Route exact path={`/analysis`} element={<Analysis />} />
              <Route exact path={`/ground_data`} element={<GroundData />} />
              <Route
                exact
                path={`/cav`}
                element={<CapacityAndVulnerability />}
              />
              <Route
                exact
                path={`/hazard_map`}
                element={<HazardMapping />}
              />
              <Route exact path={`/rainfall`} element={<Rainfall />} />
              <Route exact path={`/subsurface`} element={<Subsurface />} />
              <Route exact path={`/surficial`} element={<Surficial />} />
              <Route exact path={`/earthquake`} element={<Earthquake />} />
              <Route
                exact
                path={`/change-password`}
                element={<ChangePassword />}
              />
              <Route
                exact
                path={`/profile-settings`}
                element={<ProfileSettings />}
              />
              <Route
                exact
                path={`/surficial_markers`}
                element={<SurficialMarkers />}
              />
              <Route exact path={`/moms`} element={<Moms />} />
              <Route exact path={`/resources`} element={<Resources />} />
            </Routes>
          )}
        </Router>
      </SnackbarProvider>
    </Fragment>
  );
};

export default App;
